import httpClient from '@src/services/http.service'

const state = {
  cardTypes: [],
  cardPrices: [],
  error: '',
}

const mutations = {
  SET_CARD_TYPES: (state, types) => {
    state.cardTypes = types
  },
  SET_CARD_PRICES: (state, prices) => {
    state.cardPrices = prices
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
}

const getEshopId = () => {
  const url = new URLSearchParams(window.location.search)
  let eshopId = url.get('eshopId')
  if (eshopId == null) {
    eshopId = '77a85a2a-6b84-4d79-b856-dfafc14340a0'
  }
  return eshopId
}

const actions = {
  init: (ctx) => {
    Promise.all([
      httpClient.get(`cardCategories?eshopId=${getEshopId()}`),
      httpClient.get('pages/60bad8c6715b60a32b4d00cb'),
    ])
      .then(([cardCategoriesResponse, pricesResponse]) => {
        // const categories = cardCategoriesResponse.data.cardsCategories
        const categories = cardCategoriesResponse.data.cards
        const prices = pricesResponse.data.cards

        ctx.commit('SET_CARD_TYPES', categories)
        ctx.commit('SET_CARD_PRICES', prices)

        ctx.dispatch('calculator/setCardsCalculatorData', null, { root: true })
        ctx.dispatch('eShop/setCardsCalculatorData', null, { root: true })
      })
      .catch((error) => {
        ctx.commit('SET_ERROR', error.message)
      })
  },
}

const getters = {
  cards: (state) => state.cardTypes,
  cardPrices: (state) => state.cardPrices,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
